module.exports = __webpack_public_path__ + "8c9aa3d6ab8200b7540ad548893914af.png";